var _path, _line, _line2, _line3, _line4, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudSnow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cloud-snow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 8.01,
    y2: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8.01,
    y2: 20
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12.01,
    y2: 22
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16.01,
    y2: 16
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16.01,
    y2: 20
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSnow);
export default __webpack_public_path__ + "static/media/cloud-snow.bead1037c066e9058830127ecbfee5b6.svg";
export { ForwardRef as ReactComponent };